import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useTheme,
  useMediaQuery,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMobileNavigation = (path) => {
    setMobileOpen(false);
    // You can add navigation logic here if needed
  };

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          background: "white",
          boxShadow: "none",
          borderBottom: "1px solid #eaeaea",
        }}
      >
        <Toolbar sx={{ py: 1.5 }}>
          <Box
            component="div"
            sx={{
              flexGrow: 1,
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src="/images/company-logo.png"
              alt="SRS Perfection India Logo"
              style={{
                height: "52px",
                width: "auto",
                objectFit: "contain",
              }}
            />
          </Box>

          {isMobile ? (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ color: "#5BB5D9" }}
            >
              <MenuIcon />
            </IconButton>
          ) : (
            <Box sx={{ display: "flex", gap: 4 }}>
              <Link
                to="/"
                style={{
                  textDecoration: "none",
                  color: "#5BB5D9",
                  fontSize: "1rem",
                  fontWeight: 600,
                  transition: "color 0.3s ease",
                  "&:hover": {
                    color: "#4a9ab8",
                  },
                }}
              >
                Home
              </Link>
              <Link
                to="/about"
                style={{
                  textDecoration: "none",
                  color: "#5BB5D9",
                  fontSize: "1rem",
                  fontWeight: 600,
                }}
              >
                About
              </Link>
              <Link
                to="/services"
                style={{
                  textDecoration: "none",
                  color: "#5BB5D9",
                  fontSize: "1rem",
                  fontWeight: 600,
                  transition: "color 0.3s ease",
                  "&:hover": {
                    color: "#4a9ab8",
                  },
                }}
              >
                Services
              </Link>
              <Link
                to="/contact"
                style={{
                  textDecoration: "none",
                  color: "#5BB5D9",
                  fontSize: "1rem",
                  fontWeight: 600,
                  transition: "color 0.3s ease",
                  "&:hover": {
                    color: "#4a9ab8",
                  },
                }}
              >
                Contact
              </Link>
              <Link
                to="/products"
                style={{
                  textDecoration: "none",
                  color: "#5BB5D9",
                  fontSize: "1rem",
                  fontWeight: 600,
                  transition: "color 0.3s ease",
                  "&:hover": {
                    color: "#4a9ab8",
                  },
                }}
              >
                Products
              </Link>
              <Link
                to="/partners"
                style={{
                  textDecoration: "none",
                  color: "#5BB5D9",
                  fontSize: "1rem",
                  fontWeight: 600,
                  transition: "color 0.3s ease",
                  "&:hover": {
                    color: "#4a9ab8",
                  },
                }}
              >
                Partners
              </Link>
            </Box>
          )}
        </Toolbar>
      </AppBar>

      <Toolbar sx={{ mb: 3 }} />

      <Drawer
        variant="temporary"
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        sx={{
          "& .MuiDrawer-paper": {
            width: 240,
            boxSizing: "border-box",
            backgroundColor: "white",
          },
        }}
      >
        <List sx={{ pt: 2 }}>
          {["Home", "About", "Services", "Products", "Partners", "Contact"].map(
            (item) => (
              <ListItem
                button
                key={item}
                component={Link}
                to={item === "Home" ? "/" : `/${item.toLowerCase()}`}
                onClick={() => handleMobileNavigation(item)}
                sx={{
                  py: 1.5,
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                    "& .MuiListItemText-primary": {
                      color: "#5BB5D9",
                    },
                  },
                }}
              >
                <ListItemText
                  primary={item}
                  sx={{
                    "& .MuiListItemText-primary": {
                      color: "#333",
                      fontSize: "1rem",
                      fontWeight: 500,
                    },
                  }}
                />
              </ListItem>
            )
          )}
        </List>
      </Drawer>
    </>
  );
};

export default Navbar;
